import React, { useEffect, useState } from 'react';
import {
  Box,
  Button,
  FormControl,
  FormLabel,
  Input,
  Select,
  SimpleGrid,
  Stack,
  Text,
  Textarea,
} from '@chakra-ui/react';
import axiosInstance from '../../../api/AxiosInstance';

interface Props {
  modo: 'new' | 'edit' | 'view';
  data?: any;
  idPlan: number;
  onGuardado?: () => void;
  onCancelar?: () => void;
}

const FormularioProgramaTurismo: React.FC<Props> = ({ modo, data, idPlan, onGuardado, onCancelar }) => {
  const [form, setForm] = useState<any>({
    nombre: '',
    comunidad: '',
    tipo: '',
    descripcion: '',
    responsable: '',
    presupuesto: '',
    fechaInicio: '',
    fechaFin: '',
    estatus: 'activo',
  });
  const [guardando, setGuardando] = useState(false);

  useEffect(() => {
    if (data) {
      setForm({
        nombre: data.nombre || '',
        comunidad: data.comunidad || '',
        tipo: data.tipo || '',
        descripcion: data.descripcion || '',
        responsable: data.responsable || '',
        presupuesto: data.presupuesto || '',
        fechaInicio: data.fechaInicio ? data.fechaInicio.split('T')[0] : '',
        fechaFin: data.fechaFin ? data.fechaFin.split('T')[0] : '',
        estatus: data.estatus || 'activo',
      });
    }
  }, [data]);

  const handleChange = (field: string, value: any) => {
    setForm((prev: any) => ({ ...prev, [field]: value }));
  };

  const handleSubmit = async () => {
    if (!form.nombre || !form.comunidad || !form.tipo || !form.responsable || !form.fechaInicio || !form.fechaFin) {
      return;
    }
    setGuardando(true);
    try {
      const payload = { ...form, planId: idPlan };
      if (modo === 'edit' && data?.id) {
        await axiosInstance.put(`/turismo/programas/${data.id}`, payload);
      } else {
        await axiosInstance.post('/turismo/programas', payload);
      }
      onGuardado && onGuardado();
    } finally {
      setGuardando(false);
    }
  };

  const disabled = modo === 'view';

  return (
    <Box>
      <Stack spacing={5}>
        <Box borderWidth="1px" borderRadius="lg" p={4} bg="#f7efe8">
          <Text fontWeight="bold" color="#5b182b" mb={3}>Datos del programa</Text>
          <SimpleGrid columns={{ base: 1, md: 2 }} spacing={4}>
            <FormControl isRequired>
              <FormLabel>Nombre</FormLabel>
              <Input value={form.nombre} onChange={(e) => handleChange('nombre', e.target.value)} isDisabled={disabled} />
            </FormControl>
            <FormControl isRequired>
              <FormLabel>Comunidad</FormLabel>
              <Input value={form.comunidad} onChange={(e) => handleChange('comunidad', e.target.value)} isDisabled={disabled} />
            </FormControl>
            <FormControl isRequired>
              <FormLabel>Tipo</FormLabel>
              <Input value={form.tipo} onChange={(e) => handleChange('tipo', e.target.value)} isDisabled={disabled} />
            </FormControl>
            <FormControl isRequired>
              <FormLabel>Responsable</FormLabel>
              <Input value={form.responsable} onChange={(e) => handleChange('responsable', e.target.value)} isDisabled={disabled} />
            </FormControl>
            <FormControl>
              <FormLabel>Presupuesto</FormLabel>
              <Input type="number" value={form.presupuesto} onChange={(e) => handleChange('presupuesto', e.target.value)} isDisabled={disabled} />
            </FormControl>
            <FormControl>
              <FormLabel>Estatus</FormLabel>
              <Select value={form.estatus} onChange={(e) => handleChange('estatus', e.target.value)} isDisabled={disabled}>
                <option value="activo">Activo</option>
                <option value="concluido">Concluido</option>
              </Select>
            </FormControl>
          </SimpleGrid>
        </Box>

        <Box borderWidth="1px" borderRadius="lg" p={4}>
          <Text fontWeight="bold" color="#5b182b" mb={3}>Vigencia (rango de fechas)</Text>
          <SimpleGrid columns={{ base: 1, md: 2 }} spacing={4}>
            <FormControl isRequired>
              <FormLabel>Fecha inicio</FormLabel>
              <Input type="date" value={form.fechaInicio} onChange={(e) => handleChange('fechaInicio', e.target.value)} isDisabled={disabled} />
            </FormControl>
            <FormControl isRequired>
              <FormLabel>Fecha fin</FormLabel>
              <Input type="date" min={form.fechaInicio || undefined} value={form.fechaFin} onChange={(e) => handleChange('fechaFin', e.target.value)} isDisabled={disabled} />
            </FormControl>
          </SimpleGrid>
          <Text mt={2} fontSize="sm" color="gray.600">Usa el rango completo del programa, no una sola fecha.</Text>
        </Box>

        <Box borderWidth="1px" borderRadius="lg" p={4} bg="gray.50">
          <Text fontWeight="bold" color="#5b182b" mb={3}>Descripción</Text>
          <FormControl>
            <FormLabel>Descripción general</FormLabel>
            <Textarea value={form.descripcion} onChange={(e) => handleChange('descripcion', e.target.value)} isDisabled={disabled} rows={4} />
          </FormControl>
        </Box>
      </Stack>

      {modo !== 'view' && (
        <Box mt={6} display="flex" gap={3} justifyContent="flex-end">
          <Button onClick={onCancelar} variant="outline">Cancelar</Button>
          <Button bg="#5b182b" color="white" _hover={{ bg: '#691f30' }} onClick={handleSubmit} isLoading={guardando} loadingText="Guardando">
            Guardar
          </Button>
        </Box>
      )}
    </Box>
  );
};

export default FormularioProgramaTurismo;


